import getDateString from './locateText';
const MINUTES_IN_DAY = 1440;
const MINUTES_IN_ALMOST_TWO_DAYS = 2520;
const MINUTES_IN_MONTH = 43200;
const MINUTES_IN_TWO_MONTHS = 86400;

const formatDateDistance = (date, baseDate) => {
  const minutes = parseInt(Math.abs(new Date(date) - new Date(baseDate)) / (1000 * 60), 10);
  const seconds = Math.abs((new Date(date) - new Date(baseDate)) / 1000);
  const months = Math.abs(date.getMonth() - baseDate.getMonth() + 12 * (date.getFullYear() - baseDate.getFullYear())); // 0 up to 2 mins

  if (minutes < 2) {
    if (seconds < 40) {
      return getDateString('halfAMinute', null);
    }

    if (seconds < 60) {
      return getDateString('lessThanXMinutes', 1);
    }

    return getDateString('xMinutes', minutes);
  } // 2 mins up to 0.75 hrs


  if (minutes < 45) {
    return getDateString('xMinutes', minutes);
  } // 0.75 hrs up to 1.5 hrs


  if (minutes < 90) {
    return getDateString('aboutXHours', 1);
  } // 1 day up to 1.75 days


  if (minutes < MINUTES_IN_DAY) {
    const hours = Math.round(minutes / 60);
    return getDateString('aboutXHours', hours);
  }

  if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return getDateString('xDays', 1);
  } // 1.75 days up to 30 days


  if (minutes < MINUTES_IN_MONTH) {
    const days = Math.round(minutes / MINUTES_IN_DAY);
    return getDateString('xDays', days);
  } // 1 month up to 2 months


  if (minutes < MINUTES_IN_TWO_MONTHS) {
    const month = Math.round(minutes / MINUTES_IN_MONTH);
    return getDateString('aboutXMonths', month);
  } // 2 months up to 12 months


  if (months < 12) {
    const nearestMonth = Math.round(minutes / MINUTES_IN_MONTH);
    return getDateString('xMonths', nearestMonth);
  } // 1 year up to max Date


  const monthsSinceStartOfYear = months % 12;
  const years = Math.floor(months / 12); // N years up to 1 years 3 months

  if (monthsSinceStartOfYear < 3) {
    return getDateString('aboutXYears', years); // N years 3 months up to N years 9 months
  }

  if (monthsSinceStartOfYear < 9) {
    return getDateString('overXYears', years); // N years 9 months up to N year 12 months
  }

  return getDateString('almostXYears', years + 1);
};

export default formatDateDistance;